import React from 'react';
import { Link } from 'react-scroll';
import { ArrowDownIcon } from '@heroicons/react/24/solid'

const VerticalButton = () => {
  return (
    <div className="w-full flex justify-center items-center mb-10">
      <Link
            className="p-4 hover:text-customGreen transition cursor-pointer"
            to="biography"
            spy={true}
            smooth={true}
            duration={500}
      >
        <button className="bg-customGreen border-2 border-customGreen hover:bg-transparent text-white p-4 rounded-full flex items-center justify-center transition">
          <ArrowDownIcon className="h-12 w-5" />
        </button>
      </Link>
    </div>
  );
};

export default VerticalButton;
